var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.records.length)?_c('div',_vm._l((_vm.records),function(item){return _c('div',{key:item.id,staticClass:"mb-1"},[_c('router-link',{attrs:{"to":{ name: 'board', params: { id: item.column.board.id } }}},[_vm._v(_vm._s(item.column.board.name))]),_vm._v(" в колонке "),_c('strong',[_vm._v("«"+_vm._s(item.column.name)+"»")])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }